import { map, mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { INotificationApiDependencySegment } from '@cbridge-packages/api-notifications';
import { catchApiError } from '@cbridge-packages/api-base';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { AlertTranslator } from '@cbridge-packages/alert';
import { AlertSubscriptionAction } from '../alertSubscription.action';

type IDependencies = INotificationApiDependencySegment;

export const addEmailToSubscriptionEpic: IEpic<{}, IDependencies> = (action$, _state$, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(AlertSubscriptionAction.addEmailToSubscription.started),
  mergeMap((payload) => dependencies.nsApi
    .addEmailToSubscription(AlertTranslator.toApiAlertType(payload.type), {
      email: payload.email,
      enabled: payload.enabled,
    })
    .pipe(
      map(() => AlertSubscriptionAction.addEmailToSubscription.done({ params: payload, result: undefined })),
      catchApiError((error) => [
        AlertSubscriptionAction.addEmailToSubscription.failed({ params: payload, error }),
        createApiErrorNotification(error),
      ]),
    ),
  ),
);
